


















import { defineComponent, computed } from '@vue/composition-api';
import AppText from '@berlin-front/common/components/elements/AppText';
import { useContext } from '@berlin-front/common/composables/context';
import { ThemeContext } from '@berlin-front/common/services/ThemeContext';
import { replaceSvgColor } from '@berlin-front/common/utils';

export default defineComponent({
  name: 'IntroduceArticle',

  components: {
    AppText,
  },

  props: {
    image: {
      type: String,
      default: 'data:image/svg+xml,',
    },
  },

  setup(props) {
    const { themeParameter } = useContext(ThemeContext);
    /**
     * テーマカラーを適用したsvgイメージ。
     */
    const themedImage = computed(() =>
      replaceSvgColor(props.image, {
        '#0092CC': themeParameter.value.primaryColor || '#0092CC',
        '#F5F7FA': themeParameter.value.primaryBackgroundColor || '#F5F7FA',
      }),
    );
    return {
      themedImage,
    };
  },
});
